import styled from '@emotion/styled';
import { createElement } from 'react';

import { SPACING_UNIT } from '../../constant/spacing';

const CreationInspectionWorkflow = () => {
  return (
    <Root>
      <svg height="100%" viewBox="0 0 906.5 108" width="100%" xmlns="http://www.w3.org/2000/svg">
        <g fill="none" stroke="#ccc" strokeWidth="10">
          <path d="m28.5 20.5h127" strokeLinecap="round" />
          <path d="m429.5 20.5h472" strokeLinecap="round" />
          <path d="m165.625 20.5h248.75" strokeDasharray="5" />
        </g>
        <text fill="#3bd28d" fontFamily="HiraginoSans-W3, Hiragino Sans" fontSize="14" transform="translate(0 106)">
          <tspan x="0" y="0">
            投稿する
          </tspan>
        </text>
        <g fill="#4b556a">
          <g fontFamily="HiraginoSans-W3, Hiragino Sans" fontSize="14">
            <text transform="translate(276 106)">
              <tspan x="0" y="0">
                審査結果
              </tspan>
            </text>
            <text transform="translate(552 106)">
              <tspan x="0" y="0">
                選定結果
              </tspan>
            </text>
            <text transform="translate(839 106)">
              <tspan x="0" y="0">
                修正
              </tspan>
            </text>
          </g>
          <path
            d="m347.164 3.893-2.675-2.673a4.154 4.154 0 0 0 -5.875 0l-2.5 2.5 8.549 8.549 2.5-2.5a4.155 4.155 0 0 0 .001-5.876z"
            transform="translate(521.62 41.997)"
          />
          <path d="m0 107.863v8.549h8.549l21.112-21.112-8.548-8.549z" transform="translate(835 -39.412)" />
          <path
            d="m22.412 101.632h-18.842v-19.332h15.867l3.57-3.662h-23.007v26.654h25.982v-9.862l-3.57 3.662z"
            transform="translate(563 -30.344)"
          />
          <path
            d="m107.586 52.2-3.672 3.672 5.977 5.977 3.672 3.672 3.672-3.672 13.928-13.927-3.672-3.672-13.927 13.926z"
            transform="translate(466.837 1.751)"
          />
          <ellipse cx="304.377" cy="51.5" rx="8" ry="9.5" />
          <path
            d="m49.559 349.822a6.531 6.531 0 0 1 -.925-.581l-5.363 9.928-.381-6.5h-2.85l-.381 6.5-5.359-9.928a5.638 5.638 0 0 1 -.926.581c-2.808 1.324-9.707 5.132-9.262 12.264.107 1.712 7.135 3.488 17.357 3.488s17.25-1.776 17.357-3.488c.44-7.139-6.477-10.866-9.267-12.264z"
            transform="translate(262.914 -288.574)"
          />
          <path d="m302.877 58.845h3v4h-3z" />
        </g>
        <g transform="translate(-613 -567)">
          <g fill="#3bd28d" stroke="#fff">
            <circle cx="641.5" cy="587.5" r="13.5" stroke="none" />
            <circle cx="641.5" cy="587.5" fill="none" r="13" />
          </g>
          <text
            fill="#fff"
            fontFamily="Montserrat-Bold, Montserrat"
            fontSize="16"
            fontWeight="700"
            transform="translate(636 593)"
          >
            <tspan x="0" y="0">
              4
            </tspan>
          </text>
        </g>
        <g transform="translate(-478 -567)">
          <g fill="#4b556a" stroke="#fff">
            <circle cx="781.5" cy="587.5" r="13.5" stroke="none" />
            <circle cx="781.5" cy="587.5" fill="none" r="13" />
          </g>
          <text
            fill="#fff"
            fontFamily="Montserrat-Bold, Montserrat"
            fontSize="16"
            fontWeight="700"
            transform="translate(777 593)"
          >
            <tspan x="0" y="0">
              5
            </tspan>
          </text>
        </g>
        <g transform="translate(-338 -567)">
          <g fill="#4b556a" stroke="#fff">
            <circle cx="915.5" cy="587.5" r="13.5" stroke="none" />
            <circle cx="915.5" cy="587.5" fill="none" r="13" />
          </g>
          <text
            fill="#fff"
            fontFamily="Montserrat-Bold, Montserrat"
            fontSize="16"
            fontWeight="700"
            transform="translate(910 593)"
          >
            <tspan x="0" y="0">
              6
            </tspan>
          </text>
        </g>
        <g transform="translate(-180 -567)">
          <g fill="#4b556a" stroke="#fff">
            <circle cx="1032.5" cy="587.5" r="13.5" stroke="none" />
            <circle cx="1032.5" cy="587.5" fill="none" r="13" />
          </g>
          <text
            fill="#fff"
            fontFamily="Montserrat-Bold, Montserrat"
            fontSize="16"
            fontWeight="700"
            transform="translate(1028 593)"
          >
            <tspan x="0" y="0">
              7
            </tspan>
          </text>
        </g>
        <g fill="#3bd28d" transform="translate(11 -1.27)">
          <path d="m121.71 342.713 6.247-4.828-6.247-4.247z" transform="translate(-113.426 -266.042)" />
          <path d="m0 59.742 8.4 6.092 23.44-14.982-21.406 16.454 12.516 9.072 12.05-28.108z" />
        </g>
        <circle cx="234" cy="21" fill="#fff" r="21" />
        <circle cx="364.875" cy="21" fill="#fff" r="21" />
        <text fill="#5885b7" fontFamily="HiraginoSans-W3, Hiragino Sans" fontSize="14" transform="translate(219 27)">
          <tspan x="0" y="0">
            審査
          </tspan>
        </text>
        <text
          fill="#5885b7"
          fontFamily="HiraginoSans-W3, Hiragino Sans"
          fontSize="14"
          transform="translate(350.875 27)"
        >
          <tspan x="0" y="0">
            選定
          </tspan>
        </text>
      </svg>
    </Root>
  );
};

const Root = styled('div')({
  width: '100%',
  padding: `${SPACING_UNIT * 2}px 0`,
});

export default CreationInspectionWorkflow;
